<template>
<div class='Account'>
    <form v-if='step == 1' class="account-1" @submit.prevent="validatePasswords">
        <div class="grid">
            <div class="unit half">
                <label for="p1">
                    Password
                    <input type="password" v-model="account.password" minlength="8" id="p1" placeholder="At least 8 chars." autofocus required>
                </label>
                <label for="p2">
                    Repeat Password
                    <input type="password" v-model="account.confirmPassword" minlength="8" id="p2" placeholder="Same password again" required>
                </label>
            </div>
            <div class="unit half">
                <label>
                    Email
                    <input type="text" :value="email" disabled>
                </label>
            </div>
        </div>
        <div class="bottom-action">
            <button class="continue simple">Continue</button>
        </div>
    </form>
    <form v-if="step == '2'" class="account-2" @submit.prevent="done">
        <div class="grid">
            <div class="unit half">
                <label for="name">
                    Full Name
                    <input type="text" v-model="account.name" id="name" placeholder="John Doe" autofocus required>
                </label>
            </div>
            <div class="unit half">
                <label for="role">
                    Position
                    <input type="text" v-model="account.role" id="role" placeholder="Chief Productivity Officer" required>
                </label>
            </div>
        </div>
        <div class="bottom-action">
            <button class="continue simple">Continue</button>
        </div>
    </form>
</div>
</template>

<script>

import { loading, mixin } from './utils'
import { mapState } from 'vuex'

export default {

    mixins: [mixin],

    created () {
        this.$store.commit('updatePageInfo', {title: 'Create Account'})
    },

    computed: {
        ...mapState({
            email: state => state.account.email,
            isGDPR: state => state.account.isGDPR,
            isAdmin: state => state.account.isAdmin,
        })
    },

    data () {
        return {
            account: {
                password: '',
                passwordConfirm: '',
                name: '',
                role: ''
            }
        }
    },

    methods: {
        validatePasswords () {
            if(this.account.password === this.account.confirmPassword) {
                this.$store.commit('updateAccount', {...this.account})
                this.createUser()
            } else {
                const error = 'The passwords you entered do not match. Please enter the same password in both fields.'
                this.$store.commit('updatePageInfo', {error})
            }
        },
        createUser: loading(function() {
            var step = 0
            return this.$store
                .dispatch('createUser', this.$store.state.account)
                .then(() => {
                    step = 1
                    if (this.isAdmin)
                        return this.createCompany()
                    else {
                        return new Promise((resolve, reject) => resolve())
                    }
                }).then(() => {
                    this.$store.commit('next')
                }).catch(() => {
                    if (step === 0)
                        this.$store.dispatch('error', "An unexpected error happened when creating the user")
                    else
                        this.$store.dispatch('error', "An unexpected error happened when creating the default company")
                })

        }),
        createCompany () {
            const company = {
                names: ['GDPR Company'],
                registrationNumber: '',
                registrationCountry: '',
                employees: 0,
                industries: [],
                countries: []
            }
            return this.$store.dispatch('createCompany', company)
        },
        done () {
            this.$store.commit('updateAccount', this.account)
            this.$store.commit('next')
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// apps/account/Account.vue